// eslint-disable-next-line import/prefer-default-export
export const SET_COLUMN_ORDER = 'table-column-order/set-column-order';
